// this mutator is needed for deleteConversationItemParts
import './tryRemoveFromMailStoreItemsMutator';

import loadFolderForest from 'owa-mail-folder-forest-actions/lib/actions/loadFolderForest';
import { initializeAlwaysInCacheTableViews } from 'owa-mail-triage-local-updates/lib/actions/tableCache/alwaysInCacheTableViews';
import { loadDefaultTable } from 'owa-mail-table-loading-actions/lib/actions/loadDefaultTable';
import { initializeMailLayout } from 'owa-mail-layout';
import { conversationCache, mailStore } from 'owa-mail-store';
import deleteConversationItemParts from 'owa-mail-store-actions/lib/actions/deleteConversationItemParts';
import { verifyAndSetOptionValues } from 'owa-outlook-service-option-store';
import { getPrimeBootSettingsOptionsValues } from 'owa-session-store';
import { loadCommandBarActions } from 'owa-mail-commandbar-actions';
import { loadMailRibbonConfiguration } from 'owa-mail-ribbon-store';
import { initializeCommandingViewMode } from 'owa-command-ribbon-store';
import type { SessionData } from 'owa-service/lib/types/SessionData';
import type { ApolloClient, NormalizedCacheObject, InMemoryCache } from '@apollo/client';
import { folderTypePolicies } from 'owa-folder-typepolicies/lib/folderTypePolicies';
import { bootstrapFolderHierarchyCache } from 'owa-folders-hierarchy-bootstrap';
import { initializeSuiteHeaderPinnedPane } from 'owa-suite-header-auto-open';
import loadQuickSteps from 'owa-mail-quick-steps-store/lib/util/loadQuickSteps';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function initializeMailModuleState(
    sessionData?: SessionData | undefined,
    apolloClientPromise?: Promise<ApolloClient<NormalizedCacheObject>>
) {
    // Passing a delegate here as the delete callback to allow deleteConversationItemParts to be fully loaded by webpack.
    conversationCache.initialize(mailStore.conversations, key => {
        deleteConversationItemParts(key);
    });

    const options = getPrimeBootSettingsOptionsValues();

    verifyAndSetOptionValues(options);

    initializeCommandingViewMode(options);

    initializeSuiteHeaderPinnedPane(options);

    loadCommandBarActions();

    initializeAlwaysInCacheTableViews();

    loadDefaultTable(sessionData, apolloClientPromise);

    loadFolderForest(sessionData, apolloClientPromise);

    initializeMailLayout();

    return apolloClientPromise?.then(apolloClient => {
        loadMailRibbonConfiguration();
        if (isFeatureEnabled('tri-quickSteps')) {
            loadQuickSteps();
        }
        (apolloClient.cache as InMemoryCache).policies.addTypePolicies(folderTypePolicies);
        bootstrapFolderHierarchyCache(sessionData);
    });
}
